<template>
  <component :is="isBtn ? 'button' : 'div'" class="tag u-relative u-pad-x-sm u-white" :class="[ isBtn ? 't-button--simple is-button' : '', isActive ? 'is-active' : '', 'u-bg-' + content.sbsgradient ]"  @click="onToggleTag">
    <p class="t-text--big u-relative u-uppercase">{{content.title}}</p>

    <div v-if="isBtn" class="tag__cross u-absolute u-bg-white">
      <img src="/images/cross-dark.svg" alt="" class="tag__cross__ico u-absolute">
    </div>
  </component>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null
    },

    isBtn: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    $route (to, from) {
      this.isActive = false
    }
  },

  data()
  {
    return {
      isActive: false
    }
  },

  methods:
  {
    onToggleTag()
    {
      if(!this.isBtn)
      {
        return
      }

      this.isActive = !this.isActive

      this.$emit('toggle:tag', this.isActive, this.content)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.tag
  border-radius 7px
  padding: 8px $spacings.sm !important
  transform translateZ(0)
  
  &:before
    position absolute
    content '' !important
    top 1px
    left 1px
    bottom 1px
    right 1px
    border-radius 7px
    background: $colors.grey
    opacity 0
    transform translateZ(0) 

&.is-button
  &:before
    opacity 1

&.is-button:hover,
&.is-button.is-active
  &:before
    opacity 0
    
&.is-button.is-clear:hover,
&.is-button.is-clear.is-active
  color $colors.grey
    

.tag__cross
  $size = 18px
  
  width $size
  height $size
  top ($size/2) * -1
  right ($size/2) * -1
  border-radius 50%
  box-shadow 0px 3.22564px 16.1282px rgba(0, 0, 0, 0.15)
  opacity 0
  transform translateZ(0)
  
  .is-button.is-active &
    opacity 1
  
.tag__cross__ico
  width 6px
  top 50%
  left 50%
  transform translate(-50%, -50%)

</style>